export enum PlatformType {
  iOS = 'ios',
  Android = 'android',
  Tablet = 'tablet',
  Web = 'web',
  Adyen = 'Adyen',
}
